import React from "react";
import { 
  Button, 
  Card, 
  Text,
} from "@fluentui/react-components";
import { useNavigate } from "react-router-dom";
import MetaData from "#root/layouts/MetaData";
import { ROUTES } from "#root/routes/constants";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <MetaData
        title="404 Not Found"
        description="Sorry, the page you are looking for does not exist."
      />
      <Card appearance="filled-alternative">
        <Text size={900} weight="bold" align="center">404</Text>
        <Text size={500} align="center">Sorry, the page you are looking for does not exist.</Text>
        <Button appearance="primary" onClick={() => navigate(ROUTES.ROOT)} style={{ display: 'block', margin: '0 auto' }}>
          Back Home
        </Button>
      </Card>
    </>
  );
};

export default NotFound;
